import { token } from '@terra/ui-styled-system';

export const EXTERNAL_SCOPE_PAGE_SIZE = 50;
export const EXTERNAL_SCOPE_BULK_CONCURRENCY = 5;

const COUNT_QUERY = { limit: 1, skip: 0 } as const;

export const EXTERNAL_SCOPE_QUERIES = {
  domainTree: { limit: 500, skip: 0 },
  count: COUNT_QUERY,
  pendingCount: { ...COUNT_QUERY, scope: 'PENDING' },
  inScopeCount: { ...COUNT_QUERY, scope: 'IN_SCOPE' },
  outOfScopeCount: { ...COUNT_QUERY, scope: 'OUT_OF_SCOPE' },
  userProvided: { limit: 400, skip: 0, sourceType: 'USER_PROVIDED' },
} as const;

type ScopeBadgeStyle = {
  bg: string;
};

const SCOPE_BADGE_STYLE: Record<string, ScopeBadgeStyle> = {
  IN_SCOPE: { bg: token('colors.bg.neutral.success') },
  OUT_OF_SCOPE: { bg: token('colors.bg.neutral.error') },
  PENDING: { bg: token('colors.bg.neutral.warning') },
};

const NEUTRAL_SCOPE_BADGE_STYLE: ScopeBadgeStyle = {
  bg: token('colors.bg.neutral.muted'),
};

export function scopeBadgeStyle({
  scope,
}: {
  scope?: string | null;
}): ScopeBadgeStyle {
  if (!scope) {
    return NEUTRAL_SCOPE_BADGE_STYLE;
  }

  return SCOPE_BADGE_STYLE[scope] ?? NEUTRAL_SCOPE_BADGE_STYLE;
}
